<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';

// ref: https://developers.line.biz/ja/docs/line-social-plugins/install-guide/using-line-share-buttons
const locationPath = ref('');

onMounted(async () => {
  await nextTick();
  locationPath.value = location.href;

  if (window.LineIt) {
    window.LineIt.loadButton();
  }
});
</script>

<template>
  <ClientOnly>
    <div
      class="line-it-button"
      data-lang="ja"
      data-type="share-a"
      data-env="PROD"
      :data-url="locationPath"
      data-color="default"
      data-size="small"
      data-count="false"
      data-ver="3"
      style="display: none"
    />
  </ClientOnly>
</template>
